import { getTenderDetails } from 'lib/api/publicMarket';
import EnhancedTable from 'lib/designSystem/Table';
import { showAlert } from 'lib/functions/utils';
import { Tender } from 'lib/types/models';
import React from 'react';
import { useDispatch } from 'react-redux';
import { showTenderModal } from 'services/redux/tenderModalSlice';

export const AwardedTendersTable: React.FC<{ tenders: Tender[] }> = ({
  tenders,
}) => {
  const dispatch = useDispatch();

  const handleRowClick = async (rowId: string) => {
    try {
      if (!rowId) throw new Error('Tender ID is required');
      const tenderDetails = await getTenderDetails(dispatch, rowId);
      if (tenderDetails) dispatch(showTenderModal(tenderDetails));
    } catch (error) {
      console.error('Error fetching tender details:', error);
      showAlert(
        dispatch,
        'error',
        'Error al obtener los detalles de la licitación',
      );
    }
  };

  const headers = [
    { label: 'Código', key: 'externalCode' },
    { label: 'Nombre', key: 'name' },
    { label: 'Mandante', key: 'buyer' },
    { label: 'RUT Mandante', key: 'buyerId' },
    { label: 'Adjudicado el', key: 'adjudicationDate', type: 'date' },
    { label: 'Oferentes', key: 'bidders' },
    { label: 'Monto', key: 'estimatedAmount', type: 'money' },
  ];

  return (
    <div style={{ marginTop: '16px' }}>
      <EnhancedTable
        data={tenders}
        dataHeaders={headers}
        rowsPerPageDefault={20}
        hideTablePagination={false}
        exportToFile="csv"
        exportHeaders={headers}
        handleClickRow={handleRowClick}
      />
    </div>
  );
};
